import { CalendarDays, ClipboardCheck, Eye, MoreHorizontal, Users } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@bookdental/ui";
import { useAbrirNaOrganizacao } from "@/lib/use-abrir-na-organizacao";
import type { OrgDoPainel } from "./painel";

const item = "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-[13px] text-zinc-700 outline-none data-[highlighted]:bg-zinc-100 dark:text-foreground dark:data-[highlighted]:bg-muted";

/** Os três pontinhos da linha: abrir o mês aqui mesmo, ou ir para uma tela daquela organização
 *  (troca e navega, com "Desfazer"). */
export function AcoesDaOrganizacao({ org, onDetalhe }: { org: OrgDoPainel; onDetalhe: () => void }) {
  const { abrir } = useAbrirNaOrganizacao();
  const ir = (href: string) => abrir(org.id, org.nome, href);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          aria-label={`Ações de ${org.nome}`}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
        >
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()} className="z-[60] min-w-[220px] border border-zinc-200 bg-white p-1 shadow-xl dark:border-border dark:bg-card">
        <DropdownMenuItem className={item} onSelect={onDetalhe}>
          <Eye className="h-4 w-4" />
          Ver o mês
        </DropdownMenuItem>
        {org.clinica && (
          <DropdownMenuItem className={item} onSelect={() => ir("/agenda")}>
            <CalendarDays className="h-4 w-4" />
            Abrir a agenda
          </DropdownMenuItem>
        )}
        {org.laboratorio && (
          <DropdownMenuItem className={item} onSelect={() => ir("/lab/pedidos")}>
            <ClipboardCheck className="h-4 w-4" />
            Abrir os pedidos
          </DropdownMenuItem>
        )}
        {!org.pessoal && (
          <DropdownMenuItem className={item} onSelect={() => ir("/equipe")}>
            <Users className="h-4 w-4" />
            Equipe
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
